import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "button__wrap" }

import {computed} from 'vue';
import PLoading from '../pLoading/pLoading.vue';

interface Props {
	type?: string,
	block?: boolean,
	loading?: boolean,
	size?: 'small' | 'medium' | 'large',
	disabled?: boolean,
	loadingDiameter?: number,
}

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'pButton',
  props: {
    type: {},
    block: { type: Boolean },
    loading: { type: Boolean },
    size: { default: 'large' },
    disabled: { type: Boolean },
    loadingDiameter: { default: 16 }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// Emits
const emit = __emit;

// Computed
const classes = computed(() => ({
	'p-button_default': true,
	'p-button_border': props.type === 'border',
	'p-button_small': props.size === 'small',
	'p-button_medium': props.size === 'medium',
	'p-button_large': props.size === 'large',
	'p-button_disabled': props.disabled || props.loading,
	'p-button_block': props.block,
	'p-button_loading': props.loading,
}));

// Methods
const onClick = () => {
	emit('click', 1);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _mergeProps({
    type: "button",
    class: classes.value
  }, _ctx.$attrs, {
    disabled: _ctx.disabled,
    onClick: onClick
  }), [
    _createElementVNode("span", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(PLoading, {
            key: 0,
            diameter: _ctx.loadingDiameter
          }, null, 8 /* PROPS */, ["diameter"]))
        : _createCommentVNode("v-if", true),
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 16 /* FULL_PROPS */, _hoisted_1))
}
}

})